import { getMapValue, useWillPipe } from '@morningtrain/react-helpers'
import { useModel } from '@morningtrain/react-resources'
import useDepartments from 'support/hooks/use-departments'
import useDepartment from 'support/hooks/use-department'

export default function SelectDepartmentFromModelOnPipe ({ name = 'department_id' }) {
  const [department, setDepartment] = useDepartment()
  const [departments] = useDepartments()
  const model = useModel()

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      const departmentIdFromModel = getMapValue(model, name)
      if (departmentIdFromModel) {
        departments.forEach(departmentEntry => {
          if (parseInt(departmentEntry.id) === parseInt(departmentIdFromModel)) {
            setDepartment(departmentEntry)
          }
        })
      }

      resolve(payload)
    })
  })

  return null
}
